module.exports = __webpack_public_path__ + "static/img/3.b9967a95.jpg";